import React from 'react';
import FormLabel from '@material-ui/core/FormLabel';
import FormControl from '@material-ui/core/FormControl';
import FormGroup from '@material-ui/core/FormGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Switch from '@material-ui/core/Switch';
import text from './text';

const language = window.location.hash === '#en' ? 'eng' : 'hun';

const SEVERITY_FATAL    = 2;
const SEVERITY_SERIOUS  = 4;
const SEVERITY_MINOR    = 8;

const SEVERITIES = [SEVERITY_FATAL, SEVERITY_SERIOUS, SEVERITY_MINOR];

export default ({filter, onChange}) => {
  return (
    <div className="filterBySeverity option">
      <FormControl component="fieldset">
      <FormLabel component="legend">{text[language].filtersGroupNames.outcome}</FormLabel>
      <FormGroup>
        <div component="div" dispay="inline"> 
        {
          SEVERITIES.map(s =>
            <FormControlLabel
              key={s}
              control={
                <Switch
                  checked={(filter & s) > 0 && true}
                  selected={(filter & s) > 0}
                  onClick={() => onChange(s ^ filter)}
                  value={!"severity-" + s}
                  color="primary"
                />
              }
              label= {text[language].severity[s]}
            />
          )
        }
        </div>
        </FormGroup>
      </FormControl>
    </div>
  )
}